import {ajax} from "../../ajax";

const locations = document.querySelectorAll('.location-list .location');

let loaded = false;

if (locations.length !== 0) {
    const loadLocation = async (uid, href, popstate = false) => {
        const node = document.querySelector(`.location-list .location[data-uid="${uid}"]`);
        node.parentNode.querySelector('.active')?.classList.remove('active');
        node.classList.add('active');
    
        const response = await ajax('1687338858', { uid: uid });
        const json = await response.json();
    
        if (!popstate) {
            history.pushState({
                uid: uid,
                href: href,
            }, '', `${href}`);
        }
    
        const { addresses, contactpersons } = json;

        
        if (document.documentElement.clientWidth > 850) {
            const destopNodes = document.querySelectorAll('.destop');
        
            destopNodes.forEach(node => {
                node.querySelector('#tx-smedialocations-contactpersons')?.remove();
                node.querySelector('#tx-smedialocations-addresses')?.remove();

                const temp = document.createElement('div');
        
                // Insert addresses
                temp.innerHTML = addresses;
                const newAddresses = temp.querySelector('#tx-smedialocations-addresses');
                if (newAddresses) node.appendChild(newAddresses);
        
                // Insert contactpersons
                temp.innerHTML = contactpersons;
                const newContactpersons = temp.querySelector('#tx-smedialocations-contactpersons');
                if (newContactpersons) node.appendChild(newContactpersons);
            });
        }         
    
        return json; // ✅ Add this so mobile handler can use it
    };
    

    if (document.documentElement.clientWidth > 850) {
        
            for (const location of locations) {
                location.onclick = async e => {
                    if (e.currentTarget.classList.contains('bypass-ajax')) {
                        return;
                    }
        
                    e.preventDefault();
        
                    if (e.currentTarget.classList.contains('active')) {
                        return false;
                    }
        
                    const {uid} = e.currentTarget.dataset;
                    let base_url = window.location.origin;
                    const {href} = e.currentTarget;
                    let fixed_href =  href.replace(base_url,'');
                    loadLocation(uid, fixed_href);
                };
            }
    }
    
    
    if (document.documentElement.clientWidth < 850) {
        const contactMobil = document.querySelector('.contact-mobil');
    
        locations.forEach((link) => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
    
                const isAlreadyActive = link.classList.contains('active');
    
                // Remove active class and clear all address slots
                locations.forEach((loc) => loc.classList.remove('active'));
                document.querySelectorAll('.mobil').forEach(mob => {
                    mob.innerHTML = '';
                });
    
                // Clear contact section
                contactMobil.innerHTML = '<div id="tx-smedialocations-contactpersons"></div>';
    
                if (isAlreadyActive) return;
    
                link.classList.add('active');
    
                const uid = link.dataset.uid;
                const base_url = window.location.origin;
                const href = link.getAttribute('href') || '';
                const fixed_href = href.replace(base_url, '');
    
                const json = await loadLocation(uid, fixed_href);
    
                const mobilContainer = link.nextElementSibling;
                if (mobilContainer) {
                    mobilContainer.innerHTML = `<div id="tx-smedialocations-addresses">${json.addresses}</div>`;
                }
    
                contactMobil.innerHTML = `<div id="tx-smedialocations-contactpersons">${json.contactpersons}</div>`;
    
                link.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
                setTimeout(() => {
                    window.scrollBy(0, -100);
                }, 300);
            });
        });

        const first = locations[0];
    if (first) {
        first.click();
    }
    }
    




    window.addEventListener('popstate', async e => {
        const {uid, pathSegment, href} = e.state;
        loadLocation(uid, href, true);
    });

    if (loaded === true) {
        const activeNode = document.querySelector('.location-list .location.active');
        let node = document.querySelector('.location-list .location:first-child');

        if (activeNode) {
            node = activeNode;
        }
        const {uid} = node.dataset;

        let base_url = window.location.origin;
        const {old_href} = node.currentTarget();
        let href =  old_href.replace(base_url,'');

        history.pushState({
            uid: uid,
            href: href,
        }, '', `${href}`);
    }
}



window.addEventListener('DOMContentLoaded', (event) => {
    loaded === true;
});